import { Component } from '@theme/component';

class StudstashHero extends Component {
  #abort;
  #observer;
  #inView = false;
  #paused = false;
  #started = false;
  #motion;
  connectedCallback() {
    super.connectedCallback();
    this.#abort = new AbortController();
    const options = { signal: this.#abort.signal };
    this.#motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.querySelector('[data-motion-toggle]')?.addEventListener('click', () => {
      this.#paused = !this.#paused;
      this.sync();
    }, options);
    this.#motion.addEventListener('change', () => this.sync(), options);
    document.addEventListener('visibilitychange', () => this.sync(), options);
    this.#observer = new IntersectionObserver(entries => {
      this.#inView = entries[0].isIntersecting;
      if (this.#inView) this.load();
      this.sync();
    }, { rootMargin: '100px' });
    this.#observer.observe(this);
    this.sync();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abort?.abort();
    this.#observer?.disconnect();
    this.querySelectorAll('model-viewer').forEach(viewer => { viewer.autoRotate = false; });
  }
  async load() {
    if (this.#started || this.#motion.matches) return;
    this.#started = true;
    try {
      if (!customElements.get('model-viewer')) await import('https://cdn.jsdelivr.net/npm/@google/model-viewer@4.1.0/dist/model-viewer.min.js');
      if (!this.isConnected) { this.#started = false; return; }
      this.querySelectorAll('model-viewer').forEach(viewer => {
        viewer.addEventListener('load', () => {
          viewer.parentElement.classList.add('is-loaded');
          this.sync();
        }, { signal: this.#abort.signal });
        viewer.src = viewer.dataset.src;
        viewer.dismissPoster();
      });
      this.sync();
    } catch { this.#started = false; }
  }
  sync() {
    const stopped = this.#paused || this.#motion.matches || !this.#inView || document.hidden;
    this.toggleAttribute('data-stopped', stopped);
    this.querySelectorAll('model-viewer').forEach(viewer => { viewer.autoRotate = !stopped; });
    const button = this.querySelector('[data-motion-toggle]');
    if (button) {
      button.hidden = this.#motion.matches;
      button.textContent = this.#paused ? 'Play motion' : 'Pause motion';
      button.setAttribute('aria-pressed', String(this.#paused));
    }
    if (!stopped) this.load();
  }
}
if (!customElements.get('studstash-hero')) customElements.define('studstash-hero', StudstashHero);
